<script setup lang="ts">
import WalletStatusBanner from '~/features/my-wallet/components/WalletStatusBanner.vue'
import { useWalletStatusBanner } from '~/features/my-wallet/composables/useWalletStatusBanner'

const { statusBanner } = useWalletStatusBanner()
</script>

<template>
  <WalletStatusBanner v-if="statusBanner" :banner="statusBanner" />
</template>
